module.exports = __webpack_public_path__ + "img/fi-rr-eye-close.262bab46.svg";